import { styled, Typography, FormControlLabel as MuiFormControl } from '@mui/material'

export const Label = styled(Typography)`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  justify-content: start;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
  line-clamp: 1;
  -webkit-line-clamp: 1;
`

export const FormControlLabel = styled(MuiFormControl, {
  shouldForwardProp: (prop) => prop !== 'expand',
})<{ expand: boolean }>`
  ${({ expand }) =>
    expand &&
    `  display: flex;
  justify-content: space-between;
  margin: 0;`}
`

export const LabelContainer = styled('div')`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(0.5)};
`
